// Lib
import React, { useMemo } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

// Components
import { ReactComponent as Arrow } from '../../../assets/svg/arrow.svg';

// Styles
import { colors } from '../../../styles/palette';
import { useStyles } from './MultipleSelectStyles';

const MenuProps = (classic) => ({
  PaperProps: {
    style: {
      borderRadius: 12,
      backgroundColor: classic ? 'none' : colors.lightGrey,
      border: classic ? '1px solid #929A92' : 'none',
      marginTop: 15,
      '& ul': {
        paddingBottom: 4,
        paddingTop: 4,
      },
    },
  },
});

const MultipleSelect = ({
  items = [],
  name,
  label,
  width,
  onChangeFilter = () => {},
  className,
  required,
  classic = false,
  labelColor,
}) => {
  const checkedValues = useMemo(
    () => items.filter((item) => item.checked).map((item) => item.title),
    [items],
  );
  const { classes, cx } = useStyles({ width, labelColor });

  const renderValue = (selected) => {
    const selectedCount = selected?.length;

    if (selectedCount === 0 && label) {
      return (
        <>
          <span className={classes.label}>{label}</span>
          {required && <span className={classes.requiredWithGap}>*</span>}
        </>
      );
    }

    if (selectedCount > 1) {
      let shortestItem;
      if (selected.includes('HBV')) {
        shortestItem = 'HBV';
      } else {
        shortestItem = selected.sort((a, b) =>
          a.length < b.length ? -1 : 1,
        )[0];
      }
      return `${shortestItem} +${selectedCount - 1}`;
    } else {
      return selected?.[0];
    }
  };

  return (
    <FormControl
      className={cx(classes.control, className)}
      id={classic ? 'classic-select' : 'select'}>
      <Select
        disabled={!items.length}
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}
        IconComponent={classic ? undefined : Arrow}
        id="multiple-select"
        multiple
        value={checkedValues}
        onChange={onChangeFilter(name)}
        renderValue={renderValue}
        MenuProps={MenuProps(classic)}>
        {items?.map(({ title }, index) => (
          <MenuItem
            className={classes.menuItem}
            key={`${title}_${index}`}
            value={title}>
            <Checkbox
              className={classes.checkbox}
              checked={checkedValues?.includes(title)}
            />
            <ListItemText primary={title} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultipleSelect;
